export default __webpack_public_path__ + "static/media/oneNote.4c6f1511.svg";